import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookingResponse } from "../../Orchestrator/Types/Index";

const inflight = new Map<string, Promise<IApiResponse<IBookingResponse>>>();

export async function getBooking(bookingId: string, showLoader?: boolean): Promise<IApiResponse<IBookingResponse>> {
    const existing = inflight.get(bookingId);
    if (existing) return existing;

    const promise = (async () => {
        const ENDPOINTS = await getEndpoints();
        const endpoint = `${ENDPOINTS.getBooking}/${bookingId}`;
        return apiRequest<IBookingResponse>(endpoint, 'GET', {}, 'none', undefined, undefined, showLoader);
    })().finally(() => inflight.delete(bookingId));

    inflight.set(bookingId, promise);
    return promise;
}